<template>
  <div>

    <div class="mb-3 windows-like-breadcrumb-card shadow-sm">
      <div class="d-flex align-items-start justify-content-between w-100">
        <div v-if="currentParentCategory && currentParentCategory.name !== 'Bazowa kategoria'" class="me-3">
          <div class="d-flex align-items-center mb-1">
            <i class="fas fa-folder text-primary me-2"></i>
            <h5 class="mb-0">Aktualna kategoria: <span class="text-dark fw-semibold">{{ currentParentCategory.name }}</span></h5>
          </div>
          <p class="text-muted small mb-2" v-if="currentParentCategory.parentCategoryPath">{{ currentParentCategory.parentCategoryPath }}</p>
        </div>
        <div v-if="currentParentCategory && currentParentCategory.name !== 'Bazowa kategoria'" class="text-end flex-shrink-0">
          <button class="btn btn-light btn-sm me-2" @click="goBackToParentCategory">
            <i class="fas fa-arrow-left me-1"></i>
            Kategoria nadrzędna
          </button>
          <button class="btn btn-primary btn-sm" @click="openOrderGeneratorProductsList">
            <i class="fas fa-box-open me-1"></i>
            Produkty
          </button>
        </div>
      </div>

      <div class="product-category-data-stage">

        <div class="product-category-data-table">

          <div>
            <SearchBar2
                :searchOptions="fieldsAvailableForSearch"
                @searchRequest="searchOnList($event)"
            />

          </div>
          <div class="form-check mt-2 m-4">
            <input class="form-check-input" type="checkbox" id="search-in-subcategories" v-model="searchInSubCategories" />
            <label class="form-check-label" for="search-in-subcategories">Szukaj tylko w podkategoriach danej kategorii</label>
          </div>
          <CommonTable2
              ref="categoriesCommonTable"
              :table="tableData"
              rowIdentifier="guid"
              @onSort="sort($event)"
              @onCheckItem="checkAction($event)"
              @onItemAction="runAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="commonModule.getCategoriesTotal"
              :totalPages="commonModule.getCategoriesPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              :multiselect="multiselect"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="showMassActions"
              :showRowActions="showRowActions"
              :initiallyCheckedItemsData="selectedCategoriesData"
          />
        </div>
        <slot name="bottom"></slot>
      </div>


    </div>





    <CategoryProductListModal
        v-if="currentParentCategory"
        :showModal="showCategoryProductsListModal"
        @update:showModal="showCategoryProductsListModal = $event"
        :categoryGuid="currentParentCategory.guid"
        title="Produkty w kategorii"
    />
  </div>
</template>

<script>

import CategoryProductListModal from "@/views/DrugstoreCommonManager/CategoryProductListModal.vue";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



export default {
  name: "ParentProductCategoriesDataList",
  props: {
    multiselect: { type: Boolean, default: true },
    showMassActions: { type: Boolean, default: () => true },
    showRowActions: { type: Boolean, default: () => true },
    showAddButton: { type: Boolean, default: () => true },
    disableInitiallyCheckedItems: { type: Boolean, default: () => false },
    selectedCategoriesData: { type: Array, default: () => [] },
    categoryGuidForWhichWeSelectParent: { type: String, required: false},
  },
  emits: ["onSelect","applyItemsInSelectMode"],
  components: {
    CategoryProductListModal,
    SearchBar2,
    CommonTable2
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "ASC",
      sortingKey: "name",
      searchInSubCategories:true,
      refreshTable: true,
      showCategoryModal: false,
      categoryModalTitle: "",
      currentCategoryFormData: {},
      currentParentCategory:null,
      showCurrentCategoryProductsListModal: false,
      tableMassActions: [],
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },

      showCategoryImportAssistant: false,
      categoryTypes: {'GRUPA ASORTYMENTOWA': 'ASSORTMENT_GROUP', 'ZAMIENNIK WŁASNY': 'OWN_REPLACEMENT', 'INNY': 'OTHER'},

      fieldsAvailableForSearch: [
        {
          name: "Nazwa kategorii",
          key: "name",
        },
        {
          name: "Opis",
          key: "description",
        }
      ],

      availableHeaders: [
        {
          text: "Nazwa",
          key: "name",
          type: "text",
          sortable: true,
        },
        {
          text: "Ścieżka kategorii",
          key: "parentCategoryPath",
          type: "text",
          sortable: false,
        },
        {
          text: "Typ",
          key: "type",
          type: "text",
          sortable: true,
        },
        {
          text: "Kolejność",
          key: "orderIndex",
          type: "number",
          sortable: true,
        },
        {
          text: "Utworzono",
          key: "createdAt",
          type: "date",
          sortable: true,
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [], // no need action in parent cat selection mode
        },
      ]
    };
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {


    resetSelectedCategories(){
      if(this.$refs.categoriesCommonTable && this.$refs.categoriesCommonTable.resetCheckedItems){
        this.$refs.categoriesCommonTable.resetCheckedItems();
      }
    },

    openOrderGeneratorProductsList() {
      this.showCategoryProductsListModal = true;
    },
    goBackToParentCategory(){

      const categoryPathSplit = this.currentParentCategory.parentCategoryPath.split(">");

      if((categoryPathSplit.length === 1 && categoryPathSplit[0].length === 0) || (categoryPathSplit.length === 1 && "Bazowa kategoria" === categoryPathSplit[0])){
        this.currentParentCategory = null;
        this.refreshCategoriesList();
        return;
      }

      const payload = {
        guid: this.currentParentCategory ? this.currentParentCategory.parentCategoryGuid : null
      };

      this.commonModule.httpGetCategoryByGuid(payload).then((response) => {
        this.currentParentCategory = response.data.payload;
        this.refreshCategoriesList();
      });
    },
    // Metody do implementacji
    openImportAssistant() {
      this.showCategoryImportAssistant = true;
    },
    onImportSuccess(successStr) {
      // close modal and refresh on success
      if (successStr === 'true') {
        this.showCategoryImportAssistant = false;
        this.refreshCategoriesList();
      }
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.refreshCategoriesList();
    },

    sort(sortKey) {
      this.sortingKey = sortKey;
      this.refreshCategoriesList();
      this.toggleSortingDirection();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },



    refreshCategoriesList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy kategorii produktów");

      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: null
      };

      const payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
        parentCategoryGuid:this.currentParentCategory ? this.currentParentCategory.guid : null,
        searchInSubCategories: this.searchInSubCategories
      };

      this.refreshTable = false;
      this.commonModule.httpGetCategoriesPaging(payload).then(() => {
        const categoriesData = [];
        const categories = JSON.parse(JSON.stringify(this.commonModule.getCategoriesData));
        // Formatowanie danych kategorii
        for (const category of categories) {
          // Formatowanie daty utworzenia
          category.createdAt = this.formatDatetimeToLocaleFormat(category.createdAt);

          // Mapowanie typu kategorii na przyjazną nazwę
          category.type = this.getCategoryTypeName(category.type);

          if(this.categoryGuidForWhichWeSelectParent && category.guid === this.categoryGuidForWhichWeSelectParent){
            // skip parent category from the list
            continue;
          }


          if(!category["actions"]) {
            category["actions"] = [];
          }
          if(category.hasChildren){


            category["actions"].push({
              text: "",
              icon: "fas fa-folder-open",
              action: "open-subcategories",
              class: "btn btn-primary btn-sm table-actions-button edit-button",
              enabled: true,
              tooltip: "Otwórz podkategorie",
            })



          }
          category["actions"].push({
            text: "Wybierz",
            icon: "",
            action: "row-apply-in-select-mode",
            enabled: true,
            tooltip: "Wybierz kategorię",
            class: "btn btn-info btn-sm table-actions-button edit-button",
          })
          categoriesData.push(category);
        }

        // Aktualizacja struktury tabeli
        var categoriesHeaders = []
        for (var j = 0; j < this.availableHeaders.length; j++) {
          categoriesHeaders.push(this.availableHeaders[j]);
        }

        this.tableData["headers"] = categoriesHeaders;
        this.tableData["massActions"] = this.tableMassActions;

        this.tableData["data"] = categoriesData;

        this.refreshTable = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);
      }).catch((error) => {
        console.error('Błąd podczas pobierania kategorii:', error);
        this.lazyloaderModule.setDisplayLazyLoader(false);
      });

    },

    formatDatetimeToLocaleFormat(datetime) {
      if (!datetime) return '';
      return new Date(datetime).toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

// Pomocnicza metoda do tłumaczenia typu kategorii
    getCategoryTypeName(type) {
      const typeMap = {
        'ASSORTMENT_GROUP': 'GRUPA ASORTYMENTOWA',
        'OWN_REPLACEMENT': 'ZAMIENNIK WŁASNY',
        'OTHER': 'INNY'
      };
      return typeMap[type] || type;
    },

    checkAction(event) {
      this.$emit("onSelect", event.itemsData);
    },
    runAction(event) {
      if (event.action.action === "open-subcategories") {
        const payload = {
          guid: event.itemData.guid
        };
        this.commonModule.httpGetCategoryByGuid(payload).then((response) => {
          this.currentParentCategory = response.data.payload;
          this.refreshCategoriesList();
        });
      } else if (event.action.action  === "row-apply-in-select-mode") {
        this.$emit("applyItemsInSelectMode",[event.itemData]);
      }
    },


  },
  created() {
    this.refreshCategoriesList();
  }
};
</script>

<style scoped>
.product-category-stage-actions {
  margin-bottom: 20px;
  text-align: right;
}

.product-category-data-stage {
  margin-top: 20px;
}

.product-category-data-table {
  margin-top: 20px;
}

</style>
